export default "__VITE_ASSET__CpkZ4pZ7__"